export default __webpack_public_path__ + "static/media/tksmedia.6c69c6fb.png";